import type { GameApiRegistry } from "../app/GameApi.js";
import type { ShellSystems } from "../app/createShellSystems.js";
import type { TabRouter } from "../app/TabRouter.js";
import type { PerfTool } from "../diag/perfOverlay.js";
import type { DungeonFlow } from "./DungeonFlow.js";
import type { AutoPlaySnapshot } from "../app/buildAutoPlaySnapshot.js";

export interface GameSceneCoreApiDeps {
  readonly apiRegistry: GameApiRegistry;
  readonly getAutoPlaySnapshot: () => AutoPlaySnapshot;
  readonly tabRouter: TabRouter;
  readonly resetSave: () => void;
  readonly shell: ShellSystems;
  readonly togglePerfOverlay: () => boolean;
  readonly perf: () => PerfTool;
  readonly startTutorial: (scenarioId?: string) => void;
  readonly resetTutorial: (scenarioId?: string) => void;
  readonly dungeonFlow: () => DungeonFlow;
}

export function registerGameSceneCoreApi(deps: GameSceneCoreApiDeps): void {
  deps.apiRegistry.register({
    getAutoPlaySnapshot: deps.getAutoPlaySnapshot,
    openTab: (tab) => deps.tabRouter.setActive(tab),
    resetSave: deps.resetSave,
    cheats: deps.shell.cheats,
    togglePerfOverlay: deps.togglePerfOverlay,
    dumpPerfStats: () => deps.perf().dump(),
    startTutorial: deps.startTutorial,
    resetTutorial: deps.resetTutorial,
    performRebirth: () => deps.shell.progression.performRebirth(),
    upgradeRebirthStat: (id) => deps.shell.progression.upgradeRebirthStat(id),
    exchangeRebirthPointForStone: () => deps.shell.progression.exchangeRebirthPointForStone(),
    challengeDungeon: () => deps.dungeonFlow().challenge(),
    sweepDungeon: () => deps.dungeonFlow().sweep(),
  });
}
